<template>
  <div class="year-month-range">
    <div class="start-year-month">
      <el-select
        v-model="y1"
        class="select-range"
        size="default"
        placeholder="年"
        @change="calcVal"
      >
        <el-option v-for="item in years" :key="'y1_' + item" :value="item">{{
          item
        }}</el-option>
      </el-select>
      <el-select
        v-model="m1"
        class="select-range"
        size="default"
        placeholder="月"
        @change="calcVal"
      >
        <el-option v-for="item in months" :key="'m1_' + item" :value="item">{{
          item
        }}</el-option>
      </el-select>
    </div>
    -
    <div class="end-year-month">
      <el-select
        v-model="y2"
        class="select-range"
        size="default"
        placeholder="年"
        @change="calcVal"
      >
        <el-option v-for="item in years" :key="'y2_' + item" :value="item">{{
          item
        }}</el-option>
      </el-select>
      <el-select
        v-model="m2"
        class="select-range"
        size="default"
        placeholder="月"
        @change="calcVal"
      >
        <el-option v-for="item in months" :key="'m2_' + item" :value="item">{{
          item
        }}</el-option>
      </el-select>
    </div>
  </div>
</template>
<script>
export default {
  name: 'year-month-range',
  props: {
    value: String,
    yearRange: {
      type: Array,
      default() {
        return [1950, 2100]
      },
    },
  },
  data() {
    var years = [],
      months = []
    for (let index = this.yearRange[0]; index <= this.yearRange[1]; index++) {
      years.unshift(index.toString())
    }
    for (let index = 1; index <= 12; index++) {
      months.push(index.toString())
    }
    return {
      years,
      months,
      y1: null,
      y2: null,
      m1: null,
      m2: null,
    }
  },
  methods: {
    calcVal() {
      if (this.y1 && this.m1 && this.y2 && this.m2) {
        this.$emit(
          'input',
          this.y1 + '-' + this.m1 + '/' + this.y2 + '-' + this.m2
        )
      }
    },
  },
  watch: {
    value(newVal) {
      var dates = newVal.split('/')
      if (dates.length > 1) {
        var ds0 = dates[0].split('-')
        if (this.years.indexOf(ds0[0]) > -1) {
          this.y1 = ds0[0]
        }

        if (this.months.indexOf(ds0[1]) > -1) {
          this.m1 = ds0[1]
        }

        var ds1 = dates[1].split('-')
        if (this.years.indexOf(ds1[0]) > -1) {
          this.y2 = ds1[0]
        }

        if (this.months.indexOf(ds1[1]) > -1) {
          this.m2 = ds1[1]
        }
      }
    },
  },
}
</script>
<style lang="less">
.year-month-range {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .start-year-month,
  .end-year-month {
    width: 48%;
    display: flex;
    justify-content: space-between;
    .select-range.el-select {
      width: 49%;
      .el-input--suffix .el-input__inner {
        padding-right: 20px;
      }
    }
  }
}
@media (min-width: 768px) {
  .year-month-range {
    .start-year-month,
    .end-year-month {
      width: 46.6%;
    }
  }
}
</style>
